const copilotLocalize = {
  "cannot update when copilot is running": "cannot update when copilot is running",
};

export default copilotLocalize;